<template>
  <div class="profile-info">
    <Toolbar>
      <template #title>
        Мой профиль
      </template>
    </Toolbar>
    <ContentBlock class="profile-info__card">
      <dl class="profile-info__dl row">
        <div class="col-lg-4">
          <InfoItem title="Имя">
            {{ user.first_name }}
          </InfoItem>
        </div>
        <div class="col-lg-4">
          <InfoItem title="Фамилия">
            {{ user.last_name }}
          </InfoItem>
        </div>
        <div class="col-lg-4">
          <InfoItem title="Отчество">
            {{ user.middle_name }}
          </InfoItem>
        </div>
        <div class="col-lg-4">
          <InfoItem title="E-mail">
            {{ user.email }}
          </InfoItem>
        </div>
        <div class="col-lg-4">
          <InfoItem title="Телефон">
            {{ user.mobile_number }}
          </InfoItem>
        </div>
        <div class="col-lg-4">
          <InfoItem title="Дата рождения">
            {{ user.birthday }}
          </InfoItem>
        </div>
      </dl>
    </ContentBlock>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProfileInfoItem from "./ProfileInfoItem";
import { Toolbar } from "@/components/ui/toolbar/";

export default {
  name: "ProfileTeamToolbar",
  components: {
    Toolbar,
    InfoItem: ProfileInfoItem
  },
  props: {
    loaded: Boolean
  },
  computed: {
    ...mapGetters("auth", ["user"])
  }
};
</script>

<style lang="scss">
.profile-info {
  margin-bottom: 60px;

  &__card {
    padding: 50px;
  }

  @include breakpoint("md-and-down") {
    &__card {
      padding: 25px;
    }
  }

  @include breakpoint("sm-and-down") {
    &__dl {
      flex-direction: column;
    }
    &__card {
      padding: 15px;
    }
  }
}
</style>
